<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass"
>
  <div
    class="mb-3"
    [ngClass]="getSeverityClass()"
  >
    @if (config?.innerHTML) {
      <div [innerHTML]="config!.innerHTML"></div>
    }
  </div>
</div>
